<template>
  <v-container tag="section" fluid>
    <base-material-card
      color="primary"
      icon="mdi-bank"
      inline
      class="px-5 py-4 ml-0"
      title="Governança"
    >
      <v-row class="mx-auto">
        <v-col cols="12"> </v-col>
        <v-col cols="2">
          <v-btn
            color="primary"
            dark
            elevation="2"
            relative
            text
            medium
            @click="downloadManualIndger()"
          >
            <v-icon left size="30px"> mdi-file-pdf-box </v-icon>
            Manual da Ferramenta
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="mx-auto my-6">
        <v-col cols="12">
          <h3>Responsáveis por Temas</h3>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="itemsFiltered"
            :search="search"
            :loading="loading"
            class="elevation-1"
            disable-pagination
            hide-default-footer
            item-key="uniqueId"
          >
            <template v-slot:top>
              <v-row class="mx-auto" justify="space-between">
                <v-col cols="12" sm="auto">
                  <v-select
                    v-model="filtroBase"
                    :items="[
                      'TEC_AL',
                      'COMERCIAL',
                      'TEC_LD',
                      'TEC_SUB',
                      'SERVIÇOS',
                    ]"
                    label="Filtrar por Base"
                    clearable
                    hide-details
                  />
                </v-col>
                <v-col cols="12" sm="auto">
                  <select-company
                    ref="refSelectCompany"
                    :changeCompany="false"
                    :clearable="true"
                    @selected="filtroEmpresa = $event"
                  />
                </v-col>
                <v-col cols="12" sm="auto">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisa Geral"
                    single-line
                    clearable
                    hide-details
                  />
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.responsaveis="{ item }">
              <v-chip
                v-for="responsavel in item.responsaveis"
                :key="responsavel.id"
                color="primary"
                outlined
                class="mr-2"
              >
                {{ responsavel.user.name }}
              </v-chip>
              <span v-if="item.responsaveis.length == 0">-</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import GovernancaManualFerramentaService from "@/services/GovernancaManualFerramentaService.js";
  import GovernancaResponsaveisTemasService from "@/services/GovernancaResponsaveisTemasService.js";

  export default {
    name: "GovernancaIndex",
    components: {
      SelectCompany: () => import("@/components/general/SelectCompany"),
    },
    data: () => ({
      search: "",
      filtroBase: "",
      filtroEmpresa: "",
      headers: [
        { text: "Empresa", value: "empresa" },
        { text: "Base", value: "base" },
        { text: "Tema", value: "category" },
        { text: "Responsáveis", value: "responsaveis" },
      ],
      items: [],
      loading: false,
    }),
    computed: {
      itemsFiltered() {
        let items = this.items;

        if (this.filtroBase) {
          items = items.filter((item) => item.base === this.filtroBase);
        }
        if (this.filtroEmpresa) {
          items = items.filter(
            (item) => item.company_id === this.filtroEmpresa
          );
        }

        return items;
      },
    },
    created() {
      this.getItems();
    },
    methods: {
      downloadManualIndger() {
        GovernancaManualFerramentaService.getLinkDownloadManualIndger()
          .then((res) => {
            window.open(res.data.link, "_blank").focus();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error("Erro no download do arquivo.", "", {
              position: "topRight",
            });
          });
      },
      getItems() {
        this.loading = true;

        GovernancaResponsaveisTemasService.index()
          .then((response) => {
            this.items = response;
          })
          .catch((error) => {
            console.error("Erro ao recuperar dados:", error);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style></style>
